class XCarousel {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.xcarousel__viewport');
    this.track = root.querySelector('.xcarousel__track');
    this.slides = Array.from(root.querySelectorAll('.xcarousel__slide'));
    this.tabs = Array.from(root.querySelectorAll('.xcarousel__tab'));

    this.index = 0;
    this.width = 0;

    // drag state
    this.startX = 0;
    this.baseX = 0;
    this.currentX = 0;

    // velocity
    this.lastX = 0;
    this.lastT = 0;
    this.velocity = 0;

    // state
    this.dragging = false;
    this.moved = false;

    // ⭐关键优化参数
    this.dragThreshold = 14; // 防误触（手机建议 12~18）
    this.startTime = 0;

    this.root.addEventListener('dragstart', e => e.preventDefault());

    this.bind();
    this.update();
    this.startAutoplay();
    this.updateTabs();
  }

  bind() {
    this.root.addEventListener('pointerdown', this.onDown.bind(this));
    this.root.addEventListener('pointermove', this.onMove.bind(this));
    this.root.addEventListener('pointerup', this.onUp.bind(this));
    this.root.addEventListener('pointercancel', this.onUp.bind(this));

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.slide);
        this.go(index, true);
        this.restartAutoplay();
      });
    });

    window.addEventListener('resize', () => this.update());

    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => this.startAutoplay());
  }

  updateTabs() {
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === this.index);
    });
  }

  update() {
    if (!this.viewport) return;
    this.width = this.viewport.offsetWidth;
    this.go(this.index, false);
  }

  // =========================
  // pointerdown
  // =========================
  onDown(e) {
    if (e.target.closest('button')) return;

    this.stopAutoplay();

    this.dragging = true;
    this.moved = false;

    this.startX = e.clientX;
    this.baseX = -this.index * this.width;

    this.startTime = performance.now();

    this.track.style.transition = 'none';
  }

  // =========================
  // pointermove（关键修复点）
  // =========================
  onMove(e) {
    if (!this.dragging) return;

    const dx = e.clientX - this.startX;

    // ⭐关键：没超过阈值之前，不动 UI（解决“点一下滑一下”）
    if (Math.abs(dx) < this.dragThreshold) return;

    this.moved = true;

    this.currentX = this.baseX + dx;

    this.track.style.transform =
      `translate3d(${this.currentX}px,0,0)`;
  }

  // =========================
  // pointerup
  // =========================
  onUp(e) {
    if (!this.dragging) return;
    this.dragging = false;

    const totalMove = Math.abs(e.clientX - this.startX);
    const timeDiff = performance.now() - this.startTime;

    // =========================
    // ⭐点击判定（核心修复）
    // =========================
    const isClick =
      totalMove < this.dragThreshold &&
      timeDiff < 250;

    if (isClick) {
      this.go(this.index, true);
      this.restartAutoplay();
      this.resetState();
      return;
    }

    // =========================
    // ⭐滑动翻页逻辑
    // =========================
    const dx = this.currentX - (-this.index * this.width);

    let target = this.index;

    if (dx < 0) {
      target++;
    } else if (dx > 0) {
      target--;
    }

    this.go(target, true);
    this.restartAutoplay();

    this.resetState();
  }

  // =========================
  // reset state
  // =========================
  resetState() {
    this.moved = false;
    this.velocity = 0;
  }

  // =========================
  // go
  // =========================
  go(i, animate = true, auto = false) {
    const max = this.slides.length - 1;

    this.index = Math.max(0, Math.min(i, max));

    const x = -this.index * this.width;

    if (!animate) {
      this.track.style.transition = 'none';
    } else {
      this.track.style.transition = auto
        ? 'transform 1.5s cubic-bezier(0.22, 1, 0.36, 1)'
        : 'transform 1s cubic-bezier(0.22, 1, 0.36, 1)';
    }

    this.track.style.transform = `translate3d(${x}px,0,0)`;
    this.updateTabs();
  }

  // =========================
  // autoplay
  // =========================
  startAutoplay() {
    this.stopAutoplay();

    this.autoTimer = setInterval(() => {
      let next = this.index + 1;

      if (next >= this.slides.length) {
        next = 0;
      }

      this.go(next, true, true);
    }, 3000);
  }

  stopAutoplay() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

/* =========================
   init
========================= */
function initXCarousel() {
  document.querySelectorAll('.xcarousel').forEach(el => {
    if (!el.__carousel) {
      el.__carousel = new XCarousel(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initXCarousel);
} else {
  initXCarousel();
}

document.addEventListener('shopify:section:load', initXCarousel);